<div class="logo">
  <div class="logo_image">
    <img src="/assets/attractor-logo.png" width="65" alt="logo" />
  </div>
  <div class="logo_text">
    <div class="logo_text_main">attractor</div>
    <div class="logo_text_small">school CRM</div>
  </div>
</div>
